import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OrganizationContacts from './OrganizationContacts/OrganizationContacts';
import Communications from './Communications/Communications';
import OptionalPostalAddress from './OptionalPostalAddress/OptionalPostalAddress';
import StreetAddress from './StreetAddress/StreetAddress';
import { ORGANIZATION_ADDRESS_AND_CONTACTS_FORM_UPDATE_URL } from '../../../../../constants';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import {
  getSaveCancel,
  getFormSuccess,
  getCancelPopup,
} from '../../../../common/commonUtils/commonUtils';

const AddressAndContacts = (props) => {
  const { control, defaultValue, register, errors, useFunction } = props;
  const { handleSubmit } = useFunction;
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewOrganizationForm, setIsNewOrganizationForm] = useState(false);
  const organizationForm = useSelector((state) => state.organizationForm);

  const {
    newOrganizationForm,
    orgId,
    orgKey,
    organizationName,
    alternateName,
    accountingContactId,
    facilityCoordinatorContactId,
    parentOrganizationId,
    administrativeContactId,
    invoiceVerificationContactId,
    wCare,
    parole,
    prison,
    other,
    cbp,
    sap,
    stop,
    vendor,
    inactive,
    orgDateCreate,
    orgDateEdit,
    orgCreatedById,
    orgEditedById,
  } = organizationForm;

  const addressAndContactsForm = useSelector(
    (state) => state.addressAndContactsForm
  );

  const {
    address,
    state,
    orgCity,
    zip,
    county,
    countyId,
    sascaRegion,
    postalAddress,
    postalCity,
    postalZip,
    commPhone,
    commFax,
    commEmail,
    commWeb,
    contactList,
  } = addressAndContactsForm;

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { cityList } = organizationReferenceData;

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const getOrgCityName = () => {
    const getOrgCity = cityList.find((item) => item.id === orgCity);
    return getOrgCity?.id;
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_ADDRESS_AND_CONTACTS_FORM_UPDATE_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    const payload = {
      orgId: newOrganizationForm ? 0 : orgId,
      orgKey: orgKey,
      organizationName: organizationName,
      alternateName: alternateName,
      accountingContactId: accountingContactId ? accountingContactId : null,
      facilityCoordinatorContactId: facilityCoordinatorContactId
        ? facilityCoordinatorContactId
        : null,
      city: orgCity ? getOrgCityName() : null,
      parentOrganizationId: parentOrganizationId ? parentOrganizationId : null,
      administrativeContactId: administrativeContactId
        ? administrativeContactId
        : null,
      invoiceVerificationContactId: invoiceVerificationContactId
        ? invoiceVerificationContactId
        : null,
      wCare: wCare,
      parole: parole,
      prison: prison,
      other: other,
      cbp: cbp,
      sap: sap,
      stop: stop,
      vendor: vendor,
      inactive: inactive,
      orgDateCreate: orgDateCreate,
      orgDateEdit: orgDateEdit,
      orgCreatedById: orgCreatedById ? orgCreatedById : null,
      orgEditedById: orgEditedById ? orgEditedById : null,
      address: address,
      state: state,
      orgCity: orgCity,
      zip: zip,
      countyId: countyId ? countyId : null,
      postalAddress: postalAddress,
      postalCity: postalCity,
      postalMailZip: postalZip,
      commPhone: commPhone,
      commFax: commFax,
      commEmail: commEmail,
      commWeb: commWeb,
    };
    if (newOrganizationForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewOrganizationForm(true);
          navigate(-1);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewOrganizationForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  return (
    <>
      <StreetAddress
        control={control}
        defaultValue={defaultValue}
        register={register}
        errors={errors}
      />
      <OptionalPostalAddress
        control={control}
        register={register}
        errors={errors}
      />
      <Communications control={control} register={register} errors={errors} />
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      {newOrganizationForm ? (
        ''
      ) : (
        <OrganizationContacts orgId={orgId} contactList={contactList} />
      )}
      {getFormSuccess(formSuccess, setFormSuccess, isNewOrganizationForm)}
      {getCancelPopup(cancelPopUp, setCancelPopUp)}
    </>
  );
};

export default AddressAndContacts;
